var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"separator",class:_vm.hideCommunityOnCollapse ? 'hide-on-collapse' : ''})
}
var staticRenderFns = []

export { render, staticRenderFns }